var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.999,
    height: 28,
    viewBox: "0 0 27.999 28",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M26.445,28a1.545,1.545,0,0,1-1.1-.455L17.381,19.58a10.768,10.768,0,0,1-6.49,2.2A10.889,10.889,0,1,1,21.778,10.887a10.771,10.771,0,0,1-2.2,6.493l7.965,7.964A1.555,1.555,0,0,1,26.445,28ZM10.793,2.917a7.875,7.875,0,1,0,7.874,7.873A7.883,7.883,0,0,0,10.793,2.917Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMagnifier);
export default __webpack_public_path__ + "static/media/icon-magnifier.8f72284eb6de81afada64793417bbf0a.svg";
export { ForwardRef as ReactComponent };